import { Grid } from "@mui/material";
import { GetDocumentsArray } from ".";

const DocumentCreate = () => {
  return (
    <Grid container spacing={3} sx={{ marginTop: "50px" }}>
      <GetDocumentsArray />
    </Grid>
  );
};

export default DocumentCreate;
